/**
 * Determines if the current page is the rewards page.
 *
 * @param currentUrl - The current URL.
 * @param rewardsPageHandle - Handle of rewards page.
 * @returns - True if the current page is the rewards page, false otherwise.
 */
export const isRewardsPage = (
    currentUrl: string,
    rewardsPageHandle: string
): boolean => currentUrl.replace(/[?#].*$/, "") === rewardsPageHandle;
